import { useTranslation } from 'next-i18next';
import React from 'react';

import useRouter from 'src/shared/hooks/useRouter';
import ComparisonTable from 'src/components/ComparisonTable';
import MarketingSection from 'src/components/MarketingSection';
import ResponsiveComparisonTable from 'src/components/ResponsiveComparisonTable';
import { fireGA } from 'src/utils/gaUtils';

import styles from './styles.module.scss';
import RoutePaths from 'src/config/RoutePaths';

export default function AltiveComparisonTableSection(): JSX.Element {
    const { t } = useTranslation();
    const router = useRouter();

    const navigateToContactUsPage = () => {
        fireGA('marketingQ421', 'clickContactUs', 'WA_table');
        router.pushPath(RoutePaths.CONTACT_US);
    };

    const contentData: any = {
        titles: [
            { icon: 'icon-ico_products', text: t('product_coverage') },
            { icon: 'icon-ico_reason1', text: t('product_sourcing') },
            { icon: 'icon-ico_reason4', text: t('platform') },
            { icon: 'icon-ico_office', text: t('management_team') },
            { icon: 'icon-ico_global', text: t('global_presence') },
            { icon: 'icon-ico_reason2', text: t('fee') },
        ],
        card1: {
            header: {
                isAltive: true,
            },
            items: [
                t('altive_product_coverage'),
                t('altive_product_sourcing'),
                t('altive_platform'),
                t('altive_team'),
                t('altive_global_presence'),
                t('altive_fee'),
            ],
        },
        card2: {
            header: {
                title: t('peer'),
            },
            items: [
                t('peer_product_coverage'),
                t('peer_product_sourcing'),
                t('peer_platform'),
                t('peer_team'),
                t('peer_global_presence'),
                t('peer_fee'),
            ],
        },
        button: { text: t('contact_us'), onClick: navigateToContactUsPage },
    };

    return (
        <MarketingSection containerClassName={styles.container} className={styles.inner}>
            <p className={styles.title}>{t('why_altive_differences_title')}</p>
            <ComparisonTable {...contentData} />
            <ResponsiveComparisonTable {...contentData} />
        </MarketingSection>
    );
}
